import { render } from "./Churches.vue?vue&type=template&id=281675e2"
import script from "./Churches.vue?vue&type=script&lang=js"
export * from "./Churches.vue?vue&type=script&lang=js"

import "./Churches.vue?vue&type=style&index=0&id=281675e2&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__